// frontend/packs/home.js

/* eslint-disable import/first, import/newline-after-import */
import '../components/util/inline-filters/inline-filters.css';
import '../components/home/home-performance.css';
import '../components/home/home-main.css';

import EezyStimulusApplication from 'packs/eezy-stimulus'; // eslint-disable-line import/order

import 'components/home/values-shared/values-shared';
import 'components/home/featured-clients/featured-clients';
import 'components/home/featured-grid/featured-grid';
import 'components/home/users-are-saying/users-are-saying';

import 'components/util/load-more-button/load-more-button';

import 'components/home/why-vecteezy/why-vecteezy';
import 'components/home/creative-path/creative-path';
import 'components/home/trusted-by-brands/trusted-by-brands';
import 'components/home/creator-community/creator-community';
import 'components/home/unlock-vecteezy/unlock-vecteezy';
import 'components/home/sign-up-free/sign-up-free';
import 'components/home/explore-vectors-photos-videos/explore-vectors-photos-videos';

import FeaturedGridController from 'components/home/featured-grid/featured-grid-controller';
EezyStimulusApplication.register('featured-grid', FeaturedGridController);

import TrendingSearchesController from 'components/search/trending-searches/trending-searches-controller';
EezyStimulusApplication.register('trending-searches', TrendingSearchesController);

import UsersAreSayingController from 'components/home/users-are-saying/users-are-saying-controller';
EezyStimulusApplication.register('users-are-saying', UsersAreSayingController);

import UnlockVecteezyController from 'components/home/unlock-vecteezy/unlock-vecteezy-controller';
EezyStimulusApplication.register('unlock-vecteezy', UnlockVecteezyController);
